import qs from 'qs'
import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import config from '../../config.json'
import DropsList from '../drops/DropsList'
import { setQueryStringWithoutPageReloadPush } from '../helpers/FormatLinks'
import Page from '../page/Page'
import { Context } from '../waxplorer/Waxplorer'

const Drops = (props) => {
    let values =
        typeof window !== 'undefined'
            ? qs.parse(
                  window.location.search.substring(
                      1,
                      window.location.search.length,
                  ),
              )
            : []

    const [, dispatch] = useContext(Context)

    const collectionDetails = props['collection_details']
    const collectionName = collectionDetails ? collectionDetails['name'] : null
    const preview = collectionDetails ? collectionDetails['preview'] : null

    const { t } = useTranslation('common')

    const keyLimits = {
        drops: 10,
        calendar: 0,
    }

    const [tabKey, setTabKey] = useState(
        typeof window !== 'undefined'
            ? values['tab'] && values['tab'] in keyLimits
                ? values['tab']
                : 'drops'
            : props.tab && props.tab in keyLimits
            ? props.tab
            : 'drops',
    )

    const getAssets = async (key, initial = false) => {
        if (key === 'drops') {
            const query = values

            query['search_type'] = 'drops'
            query['order_by'] = 'date_desc'
            query['tab'] = 'drops'
            query['offer_type'] = ''

            if (tabKey !== key)
                setQueryStringWithoutPageReloadPush(qs.stringify(query))
        }

        if (key !== tabKey || initial) {
            setTabKey(key)

            dispatch({ type: 'SET_SWITCHED_TAB', payload: true })
        }
    }

    useEffect(() => {
        if (typeof window !== 'undefined') getAssets(tabKey, true)
    }, [tabKey])

    return (
        <Page
            id={'DropsPage'}
            title={config.titles.drops.replace(
                '{collectionName}',
                collectionName ? 'for ' + collectionName : '',
            )}
            description={config.descriptions.drops.replace(
                '{collectionName}',
                collectionName ? collectionName + ', ' : '',
            )}
            image={preview}
            banners={false}
            {...props}
        >
            <DropsList
                {...props}
                showFilters={true}
                page={'DropsPage'}
                isHead={true}
            />
        </Page>
    )
}

export default Drops
